import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import {orderBy} from 'lodash';
const bqGetProgramMemberSummary = async function(userId, startDate, endDate, mod) {
    // userId = 'jQwsiUWYrPVtsmJhfUFs2skKp5v2';
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

    const queryList = {
        'bmiData': `
                    SELECT 
                        HD.date, 
                        HD.bmi
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.bmi is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by 
                        HD.date 
        `,
        'waistData': `
                    SELECT 
                        HD.date, 
                        HD.waist
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.waist is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by 
                        HD.date 
        `,
        'workoutData': `
            WITH data as (
                SELECT 
                    HD.date, 
                    LAST_DAY(HD.date, WEEK(MONDAY)) lastDay,
                    HD.totalWorkout
                FROM 
                    activity_view.workout HD
                where 
                    HD.totalWorkout is not null
                    and HD.uid = '${userId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
            ),
            dataSum as (
                select lastDay, SUM(totalWorkout) workout from data group by lastDay
            ),
            dataChart as (
                SELECT
                    LAST_DAY(date, WEEK(MONDAY)) lastDay,
                    FROM UNNEST(GENERATE_DATE_ARRAY('${startDate}', '${endDate}')) AS date
                group by lastDay
            )
            select
                dataChart.lastDay,
                FORMAT_DATE('%d/%b/%y', DATE(dataChart.lastDay)) dateFormated,
                dataSum.workout
            from dataChart 
                left join dataSum on dataSum.lastDay=dataChart.lastDay
        `,
        'foodData': `
            WITH DATA as (
                SELECT 
                    date(HD.date) date, 
                    SUM(HD.serving) serving
                FROM 
                    activity_view.food HD
                where 
                    HD.serving is not null
                    and HD.uid = '${userId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
                group by 
                    date(HD.date)
            ),
            dataChart as (
                SELECT
                    date
                    FROM UNNEST(GENERATE_DATE_ARRAY('${startDate}', '${endDate}')) AS date
                ORDER BY date
            )
            select
                dataChart.date,
                data.serving
            from dataChart 
            left join data on dataChart.date=data.date
            order by dataChart.date
        `,
        'sleepData': `
            WITH DATA as (
                SELECT 
                    date(HD.date) date,
                    sum(HD.sleepHours) sleep
                FROM 
                    activity_view.sleep HD
                where 
                    HD.sleepHours is not null
                    and HD.uid = '${userId}'
                    and date(HD.date) between '${startDate}' and '${endDate}'
                group by date(HD.date)
            ),
            dataChart as (
                SELECT
                    date
                    FROM UNNEST(GENERATE_DATE_ARRAY('${startDate}', '${endDate}')) AS date
                ORDER BY date
            )
            select
                dataChart.date,
                data.sleep
            from dataChart 
            left join data on dataChart.date=data.date
            order by dataChart.date
        `,
        'bodyFatData': `
            SELECT 
                HD.date, 
                HD.bodyFat
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.bodyFat is not null
                and HD.uid = '${userId}'
                and date(HD.date) between '${startDate}' and '${endDate}'
            order by 
                HD.date 
        `,
        'weightFatData': `
            SELECT 
                HD.date, 
                HD.weight
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.weight is not null
                and HD.uid = '${userId}'
                and date(HD.date) between '${startDate}' and '${endDate}'
            order by 
                HD.date 
        `,
        'muscleData': `
            SELECT 
                HD.date, 
                HD.muscle
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.muscle is not null
                and HD.uid = '${userId}'
                and date(HD.date) between '${startDate}' and '${endDate}'
            order by 
                HD.date 
        `,
        'weightData': `
            SELECT 
                HD.date, 
                HD.weight
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.weight is not null
                and HD.uid = '${userId}'
                and date(HD.date) between '${startDate}' and '${endDate}'
            order by 
                HD.date 
        `,
        'pressureUpperData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.pressureUpper,
                HD.date dateRaw
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.pressureUpper is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'pressureLowerData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.pressureLower,
                HD.date dateRaw 
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.pressureLower is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'glucoseData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.glucose,
                HD.date dateRaw
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.glucose is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'hba1cData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.hba1c,
                HD.date dateRaw
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.hba1c is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'cholesterolData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.cholesterol,
                HD.date dateRaw 
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.cholesterol is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'hdlData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.hdl,
                HD.date dateRaw
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.hdl is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'ldlData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.ldl,
                HD.date dateRaw
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.ldl is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
        'triglyceridesData': `
            SELECT 
                DATE(HD.date) date,
                FORMAT_DATE('%d %b %y', DATE(HD.date)) dateFormated,
                HD.triglycerides,
                HD.date dateRaw
            FROM 
                thaisook_view.healthdata HD
            where 
                HD.triglycerides is not null
                and HD.uid = '${userId}'
            order by 
                HD.date desc
            limit 3
        `,
    };

    let healthDataForChart = {};
    const result = await Promise.all([
        //0: get data
        queryThaisookViewBigQuery({
            info: 'get data ' + mod + ' ' + startDate + ' - ' + endDate,
            query: queryList[mod]
        })
    ]);

    const resultData = JSON.parse(result[0].data);
    healthDataForChart = setReturnData(mod, resultData, healthDataForChart);

    return healthDataForChart;
};

const setReturnData = function( mod, resultData, healthDataForChart ){
    if( mod == 'bmiData' ){
        healthDataForChart = {
            bmi: [],
            bmiStart: 0,
            bmiEnd: 0,
            bmiMaxY: 0,
        };
        if( resultData.length ){
            const memberBMIArray = resultData.reduce((tmp, doc) => {
                if( tmp['bmi'] == undefined ){
                    tmp = {
                        bmi: [],
                        maxY: 0
                    }
                }
                tmp['bmi'].push([doc.date.value, doc.bmi]);
                if( tmp.maxY < doc.bmi*1 ){
                    tmp.maxY = doc.bmi*1;
                }
                if( healthDataForChart['bmiStart'] == 0 ){
                    healthDataForChart['bmiStart'] = doc.bmi;
                    healthDataForChart['bmiEnd'] = doc.bmi;
                }
                healthDataForChart['bmiEnd'] = doc.bmi;
                return tmp;
            }, {});
            
            healthDataForChart['bmi'] = memberBMIArray['bmi'];

            healthDataForChart['bmiMaxY'] = memberBMIArray['maxY'];
        }
    }
    else if( mod == 'waistData' ){
        healthDataForChart = {
            waist: [],
            waistStart: 0,
            waistEnd: 0,
            waistMaxY: 0,
        };
        if( resultData.length ){
            const memberWaistArray = resultData.reduce((tmp, doc) => {
                if( tmp['waist'] == undefined ){
                    tmp = {
                        waist: [],
                        maxY: 0
                    }
                }
                tmp['waist'].push([doc.date.value, doc.waist]);
                if( tmp.maxY < doc.waist*1 ){
                    tmp.maxY = doc.waist*1;
                }
                if( healthDataForChart['waistStart'] == 0 ){
                    healthDataForChart['waistStart'] = doc.waist;
                    healthDataForChart['waistEnd'] = doc.waist;
                }
                healthDataForChart['waistEnd'] = doc.waist;
                return tmp;
            }, {});
    
            healthDataForChart['waist'] = memberWaistArray['waist'];
            healthDataForChart['waistMaxY'] = memberWaistArray['maxY'];
        }
    }
    else if( mod == 'workoutData' ){
        healthDataForChart = {
            workout: [],
            workoutStart: 0,
            workoutEnd: 0,
            workoutMaxY: 0,
        };
        if( resultData.length ){
            const memberWorkoutArray = resultData.reduce((tmp, doc) => {
                if( tmp['workout'] == undefined ){
                    tmp = {
                        workout: [],
                        maxY: 0
                    }
                }
                
                tmp['workout'].push({x: doc.lastDay.value, y: doc.workout, sort: doc.lastDay.value});
                if( tmp.maxY < doc.workout*1 ){
                    tmp.maxY = doc.workout*1;
                }
                if( doc.workout ){
                    if( healthDataForChart['workoutStart'] == 0){
                        healthDataForChart['workoutStart'] = doc.workout;
                        healthDataForChart['workoutEnd'] = doc.workout;
                    }
                    healthDataForChart['workoutEnd'] = doc.workout;
                }
                return tmp;
            }, {});
            healthDataForChart['workout'] = orderBy(memberWorkoutArray['workout'], ['sort'], ['asc']);
            healthDataForChart['workoutMaxY'] = memberWorkoutArray['maxY'];
        }
    }
    else if( mod == 'foodData' ){
        healthDataForChart = {
            food: [],
            foodStart: 0,
            foodEnd: 0,
            foodMaxY: 0,
        };
        if( resultData.length ){
            const memberFoodArray = resultData.reduce((tmp, doc) => {
                if( tmp['food'] == undefined ){
                    tmp = {
                        food: [],
                        maxY: 0
                    }
                }
                tmp['food'].push([doc.date.value, doc.serving]);
                if( tmp.maxY < doc.serving*1 ){
                    tmp.maxY = doc.serving*1;
                }
                if( doc.serving ){
                    if( healthDataForChart['foodStart'] == 0){
                        healthDataForChart['foodStart'] = doc.serving;
                        healthDataForChart['foodEnd'] = doc.serving;
                    }
                    healthDataForChart['foodEnd'] = doc.serving;
                }
                return tmp;
            }, {});
            healthDataForChart['food'] = memberFoodArray['food'];
            healthDataForChart['foodMaxY'] = memberFoodArray['maxY'];
        }

    }else if( mod == 'sleepData' ){
        healthDataForChart = {
            sleep: [],
            sleepStart: 0,
            sleepEnd: 0,
            sleepMaxY: 0,
        };
        if( resultData.length ){
            const memberSleepArray = resultData.reduce((tmp, doc) => {
                if( tmp['sleep'] == undefined ){
                    tmp = {
                        sleep: [],
                        maxY: 0
                    }
                }
                tmp['sleep'].push([doc.date.value, doc.sleep]);
                if( tmp.maxY < doc.sleep*1 ){
                    tmp.maxY = doc.sleep*1;
                }
                if( doc.sleep ){
                    if( healthDataForChart['sleepStart'] == 0){
                        healthDataForChart['sleepStart'] = doc.sleep;
                        healthDataForChart['sleepEnd'] = doc.sleep;
                    }
                    healthDataForChart['sleepEnd'] = doc.sleep;
                }
                return tmp;
            }, {});
            healthDataForChart['sleep'] = memberSleepArray['sleep'];
            healthDataForChart['sleepMaxY'] = memberSleepArray['maxY'];
        }

    }
    else if( mod == 'bodyFatData' ){
        healthDataForChart = {
            bodyFat: [],
            bodyFatStart: 0,
            bodyFatEnd: 0,
            bodyFatMaxY: 0,
        };
        if( resultData.length ){
            const memberBodyFatArray = resultData.reduce((tmp, doc) => {
                if( tmp['bodyFat'] == undefined ){
                    tmp = {
                        bodyFat: [],
                        maxY: 0
                    }
                }
                tmp['bodyFat'].push([doc.date.value, doc.bodyFat]);
                if( tmp.maxY < doc.bodyFat*1 ){
                    tmp.maxY = doc.bodyFat*1;
                }
                if( healthDataForChart['bodyFatStart'] == 0 ){
                    healthDataForChart['bodyFatStart'] = doc.bodyFat;
                    healthDataForChart['bodyFatEnd'] = doc.bodyFat;
                }
                healthDataForChart['bodyFatEnd'] = doc.bodyFat;
                return tmp;
            }, {});
            
            if( memberBodyFatArray['bodyFat'].length > 1 ){
                healthDataForChart['bodyFat'].push(memberBodyFatArray['bodyFat'][0]);
                healthDataForChart['bodyFat'].push(memberBodyFatArray['bodyFat'][(memberBodyFatArray['bodyFat'].length-1)]);
            }
            else{
                healthDataForChart['bodyFat'] = memberBodyFatArray['bodyFat'];
            }

            healthDataForChart['bodyFatMaxY'] = memberBodyFatArray['maxY'];
        }
    }
    else if( mod == 'muscleData' ){
        healthDataForChart = {
            muscle: [],
            muscleStart: 0,
            muscleEnd: 0,
            muscleMaxY: 0,
        };
        if( resultData.length ){
            const memberMuscleArray = resultData.reduce((tmp, doc) => {
                if( tmp['muscle'] == undefined ){
                    tmp = {
                        muscle: [],
                        maxY: 0
                    }
                }
                tmp['muscle'].push([doc.date.value, doc.muscle]);
                if( tmp.maxY < doc.muscle*1 ){
                    tmp.maxY = doc.muscle*1;
                }
                if( healthDataForChart['muscleStart'] == 0 ){
                    healthDataForChart['muscleStart'] = doc.muscle;
                    healthDataForChart['muscleEnd'] = doc.muscle;
                }
                healthDataForChart['muscleEnd'] = doc.muscle;
                return tmp;
            }, {});
            
            if( memberMuscleArray['muscle'].length > 1 ){
                healthDataForChart['muscle'].push(memberMuscleArray['muscle'][0]);
                healthDataForChart['muscle'].push(memberMuscleArray['muscle'][(memberMuscleArray['muscle'].length-1)]);
            }
            else{
                healthDataForChart['muscle'] = memberMuscleArray['muscle'];
            }

            healthDataForChart['muscleMaxY'] = memberMuscleArray['maxY'];
        }
    }
    else if( mod == 'weightData' ){
        healthDataForChart = {
            weight: [],
            weightStart: 0,
            weightEnd: 0,
            weightMaxY: 0,
        };
        if( resultData.length ){
            const memberWeightArray = resultData.reduce((tmp, doc) => {
                if( tmp['weight'] == undefined ){
                    tmp = {
                        weight: [],
                        maxY: 0
                    }
                }
                tmp['weight'].push([doc.date.value, doc.weight]);
                if( tmp.maxY < doc.weight*1 ){
                    tmp.maxY = doc.weight*1;
                }
                if( healthDataForChart['weightStart'] == 0 ){
                    healthDataForChart['weightStart'] = doc.weight;
                    healthDataForChart['weightEnd'] = doc.weight;
                }
                healthDataForChart['weightEnd'] = doc.weight;
                return tmp;
            }, {});
            
            // if( memberWeightArray['weight'].length > 1 ){
            //     healthDataForChart['weight'].push(memberWeightArray['weight'][0]);
            //     healthDataForChart['weight'].push(memberWeightArray['weight'][(memberWeightArray['weight'].length-1)]);
            // }
            // else{
            //     healthDataForChart['weight'] = memberWeightArray['weight'];
            // }

            healthDataForChart['weight'] = memberWeightArray['weight'];

            healthDataForChart['weightMaxY'] = memberWeightArray['maxY'];
        }
    }
    else if( mod == 'pressureUpperData' ){
        healthDataForChart = {
            pressureUpper: [],
            pressureUpperStart: 0,
            pressureUpperEnd: 0,
            pressureUpperMaxY: 0,
        };
        if( resultData.length ){
            const memberPressureUpperArray = resultData.reduce((tmp, doc) => {
                if( tmp['pressureUpper'] == undefined ){
                    tmp = {
                        pressureUpper: [],
                        maxY: 0
                    }
                }
                tmp['pressureUpper'].push({ x: doc.dateFormated, y: doc.pressureUpper, sort: doc.dateRaw.value});
                if( tmp.maxY < doc.pressureUpper*1 ){
                    tmp.maxY = doc.pressureUpper*1;
                }
                if( healthDataForChart['pressureUpperStart'] == 0 ){
                    healthDataForChart['pressureUpperStart'] = doc.pressureUpper;
                    healthDataForChart['pressureUpperEnd'] = doc.pressureUpper;
                }
                healthDataForChart['pressureUpperEnd'] = doc.pressureUpper;
                return tmp;
            }, {});
            
            if( memberPressureUpperArray['pressureUpper'].length < 3 ){
                let cnt = memberPressureUpperArray['pressureUpper'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberPressureUpperArray['pressureUpper'].push({ x: '-', y: null, sort: 999});
                }
            }
            
            healthDataForChart['pressureUpper'] = orderBy(memberPressureUpperArray['pressureUpper'], ['sort'], ['asc']);
            healthDataForChart['pressureUpperMaxY'] = memberPressureUpperArray['maxY'];
        }
    }
    else if( mod == 'pressureLowerData' ){
        healthDataForChart = {
            pressureLower: [],
            pressureLowerStart: 0,
            pressureLowerEnd: 0,
            pressureLowerMaxY: 0,
        };
        if( resultData.length ){
            const memberPressureLowerArray = resultData.reduce((tmp, doc) => {
                if( tmp['pressureLower'] == undefined ){
                    tmp = {
                        pressureLower: [],
                        maxY: 0
                    }
                }
                tmp['pressureLower'].push({ x: doc.dateFormated, y: doc.pressureLower, sort: doc.dateRaw.value});
                if( tmp.maxY < doc.pressureLower*1 ){
                    tmp.maxY = doc.pressureLower*1;
                }
                if( healthDataForChart['pressureLowerStart'] == 0 ){
                    healthDataForChart['pressureLowerStart'] = doc.pressureLower;
                    healthDataForChart['pressureLowerEnd'] = doc.pressureLower;
                }
                healthDataForChart['pressureLowerEnd'] = doc.pressureLower;
                return tmp;
            }, {});
            
            if( memberPressureLowerArray['pressureLower'].length < 3 ){
                let cnt = memberPressureLowerArray['pressureLower'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberPressureLowerArray['pressureLower'].push({ x: '-', y: null, sort: 999});
                }
            }

            healthDataForChart['pressureLower'] = orderBy(memberPressureLowerArray['pressureLower'], ['sort'], ['asc']);
            healthDataForChart['pressureLowerMaxY'] = memberPressureLowerArray['maxY'];
        }
    }
    else if( mod == 'glucoseData' ){
        healthDataForChart = {
            glucose: [],
            glucoseStart: 0,
            glucoseEnd: 0,
            glucoseMaxY: 0,
        };
        if( resultData.length ){
            const memberGlucoseArray = resultData.reduce((tmp, doc) => {
                if( tmp['glucose'] == undefined ){
                    tmp = {
                        glucose: [],
                        maxY: 0
                    }
                }
                tmp['glucose'].push({ x: doc.dateFormated, y: doc.glucose, sort: doc.dateRaw.value });
                if( tmp.maxY < doc.glucose*1 ){
                    tmp.maxY = doc.glucose*1;
                }
                if( healthDataForChart['glucoseStart'] == 0 ){
                    healthDataForChart['glucoseStart'] = doc.glucose;
                    healthDataForChart['glucoseEnd'] = doc.glucose;
                }
                healthDataForChart['glucoseEnd'] = doc.glucose;
                return tmp;
            }, {});
            
            if( memberGlucoseArray['glucose'].length < 3 ){
                let cnt = memberGlucoseArray['glucose'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberGlucoseArray['glucose'].push({ x: '-', y: null, sort: 999});
                }
            }
            
            healthDataForChart['glucose'] = orderBy(memberGlucoseArray['glucose'], ['sort'], ['asc']);
            healthDataForChart['glucoseMaxY'] = memberGlucoseArray['maxY'];
        }
    }
    else if( mod == 'hba1cData' ){
        healthDataForChart = {
            hba1c: [],
            hba1cStart: 0,
            hba1cEnd: 0,
            hba1cMaxY: 0,
        };
        if( resultData.length ){
            const memberHba1cArray = resultData.reduce((tmp, doc) => {
                if( tmp['hba1c'] == undefined ){
                    tmp = {
                        hba1c: [],
                        maxY: 0
                    }
                }
                tmp['hba1c'].push({ x: doc.dateFormated, y: doc.hba1c, sort: doc.dateRaw.value});
                if( tmp.maxY < doc.hba1c*1 ){
                    tmp.maxY = doc.hba1c*1;
                }
                if( healthDataForChart['hba1cStart'] == 0 ){
                    healthDataForChart['hba1cStart'] = doc.hba1c;
                    healthDataForChart['hba1cEnd'] = doc.hba1c;
                }
                healthDataForChart['hba1cEnd'] = doc.hba1c;
                return tmp;
            }, {});
            
            if( memberHba1cArray['hba1c'].length < 3 ){
                let cnt = memberHba1cArray['hba1c'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberHba1cArray['hba1c'].push({ x: '-', y: null, sort: 999});
                }
            }
            
            healthDataForChart['hba1c'] = orderBy(memberHba1cArray['hba1c'], ['sort'], ['asc']);
            healthDataForChart['hba1cMaxY'] = memberHba1cArray['maxY'];
        }
    }
    else if( mod == 'cholesterolData' ){
        healthDataForChart = {
            cholesterol: [],
            cholesterolStart: 0,
            cholesterolEnd: 0,
            cholesterolMaxY: 0,
        };
        if( resultData.length ){
            const memberCholesterolArray = resultData.reduce((tmp, doc) => {
                if( tmp['cholesterol'] == undefined ){
                    tmp = {
                        cholesterol: [],
                        maxY: 0
                    }
                }
                tmp['cholesterol'].push({ x: doc.dateFormated, y: doc.cholesterol, sort: doc.dateRaw.value});
                if( tmp.maxY < doc.cholesterol*1 ){
                    tmp.maxY = doc.cholesterol*1;
                }
                if( healthDataForChart['cholesterolStart'] == 0 ){
                    healthDataForChart['cholesterolStart'] = doc.cholesterol;
                    healthDataForChart['cholesterolEnd'] = doc.cholesterol;
                }
                healthDataForChart['cholesterolEnd'] = doc.cholesterol;
                return tmp;
            }, {});
            
            if( memberCholesterolArray['cholesterol'].length < 3 ){
                let cnt = memberCholesterolArray['cholesterol'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberCholesterolArray['cholesterol'].push({ x: '-', y: null, sort: 999});
                }
            }
            
            healthDataForChart['cholesterol'] = orderBy(memberCholesterolArray['cholesterol'], ['sort'], ['asc']);
            healthDataForChart['cholesterolMaxY'] = memberCholesterolArray['maxY'];
        }
    }
    else if( mod == 'hdlData' ){
        healthDataForChart = {
            hdl: [],
            hdlStart: 0,
            hdlEnd: 0,
            hdlMaxY: 0,
        };
        if( resultData.length ){
            const memberHdlArray = resultData.reduce((tmp, doc) => {
                if( tmp['hdl'] == undefined ){
                    tmp = {
                        hdl: [],
                        maxY: 0
                    }
                }
                tmp['hdl'].push({ x: doc.dateFormated, y: doc.hdl, sort: doc.dateRaw.value});
                if( tmp.maxY < doc.hdl*1 ){
                    tmp.maxY = doc.hdl*1;
                }
                if( healthDataForChart['hdlStart'] == 0 ){
                    healthDataForChart['hdlStart'] = doc.hdl;
                    healthDataForChart['hdlEnd'] = doc.hdl;
                }
                healthDataForChart['hdlEnd'] = doc.hdl;
                return tmp;
            }, {});
            
            if( memberHdlArray['hdl'].length < 3 ){
                let cnt = memberHdlArray['hdl'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberHdlArray['hdl'].push({ x: '-', y: null, sort: 999});
                }
            }
            healthDataForChart['hdl'] = orderBy(memberHdlArray['hdl'], ['sort'], ['asc']);
            healthDataForChart['hdlMaxY'] = memberHdlArray['maxY'];
        }
    }
    else if( mod == 'ldlData' ){
        healthDataForChart = {
            ldl: [],
            ldlStart: 0,
            ldlEnd: 0,
            ldlMaxY: 0,
        };
        if( resultData.length ){
            const memberLdlArray = resultData.reduce((tmp, doc) => {
                if( tmp['ldl'] == undefined ){
                    tmp = {
                        ldl: [],
                        maxY: 0
                    }
                }
                tmp['ldl'].push({ x: doc.dateFormated, y: doc.ldl, sort: doc.dateRaw.value });
                if( tmp.maxY < doc.ldl*1 ){
                    tmp.maxY = doc.ldl*1;
                }
                if( healthDataForChart['ldlStart'] == 0 ){
                    healthDataForChart['ldlStart'] = doc.ldl;
                    healthDataForChart['ldlEnd'] = doc.ldl;
                }
                healthDataForChart['ldlEnd'] = doc.ldl;
                return tmp;
            }, {});

            if( memberLdlArray['ldl'].length < 3 ){
                let cnt = memberLdlArray['ldl'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberLdlArray['ldl'].push({ x: '-', y: null, sort: 999});
                }
            }
            healthDataForChart['ldl'] = orderBy(memberLdlArray['ldl'], ['sort'], ['asc']);
            healthDataForChart['ldlMaxY'] = memberLdlArray['maxY'];
        }
    }
    else if( mod == 'triglyceridesData' ){
        healthDataForChart = {
            triglycerides: [],
            triglyceridesStart: 0,
            triglyceridesEnd: 0,
            triglyceridesMaxY: 0,
        };
        if( resultData.length ){
            const memberTriglyceridesArray = resultData.reduce((tmp, doc) => {
                if( tmp['triglycerides'] == undefined ){
                    tmp = {
                        triglycerides: [],
                        maxY: 0
                    }
                }
                tmp['triglycerides'].push({ x: doc.dateFormated, y: doc.triglycerides, sort: doc.dateRaw.value});
                if( tmp.maxY < doc.triglycerides*1 ){
                    tmp.maxY = doc.triglycerides*1;
                }
                if( healthDataForChart['triglyceridesStart'] == 0 ){
                    healthDataForChart['triglyceridesStart'] = doc.triglycerides;
                    healthDataForChart['triglyceridesEnd'] = doc.triglycerides;
                }
                healthDataForChart['triglyceridesEnd'] = doc.triglycerides;
                return tmp;
            }, {});

            if( memberTriglyceridesArray['triglycerides'].length < 3 ){
                let cnt = memberTriglyceridesArray['triglycerides'].length;
                for( let i = cnt; i < 3; i++ ){
                    memberTriglyceridesArray['triglycerides'].push({ x: '-', y: null, sort: 999});
                }
            }

            healthDataForChart['triglycerides'] = orderBy(memberTriglyceridesArray['triglycerides'], ['sort'], ['asc']);
            healthDataForChart['triglyceridesMaxY'] = memberTriglyceridesArray['maxY'];
        }
    }
    return healthDataForChart;
};

export default bqGetProgramMemberSummary;